// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"2dac3fb4","38":"eb72138a","110":"e674fbfe","341":"b1de8040","437":"37c5c459","488":"e9055f35","538":"f75ed074","566":"8a624cb4","680":"3a1ff085","787":"752b9a1f","883":"268feada"}[chunkId] + ".chunk.js";
};